import { render, staticRenderFns } from "./DcBalance.vue?vue&type=template&id=fa4c3bfa&scoped=true&"
import script from "./DcBalance.vue?vue&type=script&lang=js&"
export * from "./DcBalance.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=fa4c3bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c3bfa",
  null
  
)

export default component.exports